const projectsOBJ = [
    {
        Thumbnail: "/img/MovieDex.JPEG",
        Name: "MovieDex",
        Description: "A Movie Database Website that provides movie ratings, descriptions, and a search functionality using the Movie Database API.",
        Technology: ["React", "HTML", "CSS", "Javascript"],
        SiteLink: "https://moviedex.vercel.app/",
        GitLink: "https://github.com/DTran990/MovieDex"
    },
    {
        Thumbnail: "/img/BookSearcher.JPEG",
        Name: "BookSearcher",
        Description: "A Book Search Website that provides Book information from the Google Books API.",
        Technology: ["React", "Redux", "Router" , "HTML", "CSS", "Javascript"],
        SiteLink: "https://book-searcher-seven.vercel.app/",
        GitLink: "https://github.com/DTran990/Booksearcher"
    },
    {
        Thumbnail: "/img/Portfolio.JPEG",
        Name: "Portfolio",
        Description: "My Personal Portfolio.",
        Technology: ["React", "HTML", "CSS", "Javascript"],
        SiteLink: "https://trandavid.ca/",
        GitLink: "https://github.com/DTran990/ReactPortfolio"
    },
    {
        Thumbnail: "/img/ReFresh.JPEG",
        Name: "ReFresh",
        Description: "A Mock therapy website with smooth scrolling and active page classes.",
        Technology: ["HTML", "CSS", "Javascript", "Bootstrap"],
        SiteLink: "https://dtrefresh.000webhostapp.com/#Homepage",
        GitLink: "https://github.com/DTran990/ReFresh"
    },
    {
        Thumbnail: "/img/Necessities.JPEG",
        Name: "Necessities App",
        Description: "A web application that includes local date and time, timer/stopwatch, weather app using the AccuWeather API, todo list, and calculator",
        Technology: ["HTML", "CSS", "Javascript"],
        SiteLink: "https://dt-necessities.000webhostapp.com/index.html",
        GitLink: "https://github.com/DTran990/Necessities-Project"
    },
    {
        Thumbnail: "/img/ClosedWeather.JPEG",
        Name: "ClosedWeather App",
        Description: "A Weather application made by myself and 3 group members using the OpenWeather and Spotify API.",
        Technology: ["React", "HTML", "CSS", "Javascript", "JQuery", "Bootstrap", "PHP", "MySQL"],
        SiteLink: "https://cps530arbenson.000webhostapp.com/index.php",
        GitLink: "https://github.com/singh13sagar/weather/tree/david_hourly"
    },
    {
        Thumbnail: "/img/Eduquat.JPEG",
        Name: "Eduquat",
        Description: "A Mock education website.",
        Technology: ["HTML", "CSS"],
        SiteLink: "https://eduquation.000webhostapp.com/index.html",
        GitLink: "https://github.com/DTran990/Eduquation"
    }
]

export default projectsOBJ
